import { ErrorHandler, inject, Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataMessageService } from './data-message.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  sn: string;
  userID: string;
  userLastNm: string;
  userFirstNm: string;
  private _http = inject(HttpClient);
  private _dataMsgService = inject(DataMessageService);

  constructor() {
    // Subscribe to the sn observable to get the latest value
    this._dataMsgService.currentSnStr.subscribe(snStr => this.snChange(snStr));
    this._dataMsgService.currentUserIdStr.subscribe(userIdStr => this.userIdChange(userIdStr)); // Subscription looking for changes in userIdStr
    this._dataMsgService.currentUserLastNmStr.subscribe(userLastNmStr => this.userLastNmChange(userLastNmStr)); // Subscription looking for changes in userLastNmStr
    this._dataMsgService.currentUserFirstNmStr.subscribe(userFirstNmStr => this.userFirstNmChange(userFirstNmStr)); // Subscription looking for changes in userLastNmStr
  }

  handleError(error: any): void {
    // Log the error to the console
    console.error('An unexpected error occurred:', error);

    // Prepare error payload
    const errorPayload = {
      message: error.message || error.toString(),
      stack: error.stack || '',
      time: new Date().toISOString(),
      sn: this.sn,
      user: this.userLastNm + ', ' + this.userFirstNm + ' (' + this.userID + ')'
      // Add more contextual information if needed
    };
    console.log('errorPayload', errorPayload);

    // Send error details to the private API
    this._http.post('https://medicalbiller.us/api/ng-rt-errs', errorPayload).subscribe({
      next: () => {
        // Successfully sent error details
      },
      error: (err) => {
        // Handle error while sending error details
        console.error('Failed to send error details:', err);
      },
    });

    // Optionally, rethrow the error if you want it to propagate further
    // throw error;
  }

  snChange(snStr: string) { // for when sn changes
    this.sn = snStr;
  }

  userIdChange(userIdStr) {
    this.userID = userIdStr;
  }

  userLastNmChange(userLastNmStr) {
    this.userLastNm = userLastNmStr;
  }

  userFirstNmChange(userFirstNmStr) {
    this.userFirstNm = userFirstNmStr;
  }
}